import { gsap } from "gsap"
//import { ScrollTrigger } from "gsap/ScrollTrigger"

//gsap.registerPlugin(ScrollTrigger)

/*--------------------
Splitting text
--------------------*/
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

Splitting();

const target = document.querySelectorAll('.name-item h1');
const results = Splitting({ target: target, by: 'chars' });

/*--------------------
Contants
--------------------*/
const speedWheel = 0.008
const speedDrag = -0.1

/*--------------------
Get Z
--------------------*/
const getZindex = (array, index) => (array.map((_, i) => (index === i) ? array.length : array.length - Math.abs(index - i)))

/*--------------------
Items
--------------------*/
const $items = document.querySelectorAll('.carousel-wrapper')
const $names = document.querySelectorAll('.name-item')
//const $names_char = document.querySelectorAll('.name-item h1 span .char')
const carouselW = document.getElementsByClassName("carousel_flex")

/*--------------------
MATCH MEDIA
--------------------*/
let mm = gsap.matchMedia(),
    breakPoint = 800;

mm.add({

  isDesktop: `(min-width: ${breakPoint}px)`,
  isMobile: `(max-width: ${breakPoint - 1}px)`,
  reduceMotion: "(prefers-reduced-motion: reduce)"

}, (context) => {
  /*--------------------
  Vars
  --------------------*/
  let executed = false
  let okDelta = true
  let progress = 50
  let startX = 0
  let active = 0
  let isDown = false
  let maxLength = $items.length
  let { isDesktop, isMobile, reduceMotion } = context.conditions;

  let displayNum = isDesktop ? 4 : 2
  let item_width = isDesktop ? 240 : 168
  let displayMargin = (window.innerWidth-(displayNum * item_width))/displayNum

  /*--------------------
  Title
  -----------------------*/
  const displayNames = (name, index, active) => {
    name.style.setProperty('--active', (index-active)/$names.length)
  }

  const animateTitle = () => {
    //console.log("animate title")
    $names.forEach((name, index) => displayNames(name, index, active))
  }
  animateTitle()

  /*--------------------
  Reset
  --------------------*/

  const resetPage = (e) => {
    //console.log("Resize")
    active = 0
    animateTitle()
    gsap.to(".carousel_flex", {
      x: 0,
      }
    );
    gsap.to(".box", {
      x: 0,
      scale: isDesktop ? 1 : 0.7,
      ease: "power1.inOut",
      }
    );
    //displayNum = isDesktop ? 4 : 2
    displayMargin = (window.innerWidth-(displayNum * item_width))/displayNum
    //console.log("MARGIN: "+ displayMargin + ", ACTIVE: "+ active)
  }

  window.addEventListener("resize", resetPage);

  /* NEW ================================================================== */

  function onCompleted(num) {
    if(active >= 0 && active <= $items.length){
      active = active + num
      console.log("COMPLETED ACTIVE = " + active)
      animateTitle()
    }
    setTimeout(function(){ executed = false; }, 150*$items.length);
    //executed = false;
  }

  function animatePrev() {
    if(active >= 1){
      console.log("PREV: active = " + active)
      gsap.to(".box", {
          x: "+=" + (displayMargin+item_width),
          scale: isDesktop ? 1 : 0.7,
          stagger: {
            //each:0.3,
            amount: 0.6,
            axis: "x", 
            ease: "back.easeOut",
            from: active,
          },
          onComplete:onCompleted(-1),
        }
      );
    }else{
      onCompleted(0)
    }
  }
  function animateNext() {
    if(active < $items.length-1){
      console.log("NEXT: active = " + active)
      gsap.to(".box", {
          x: "-=" + (displayMargin+item_width),
          scale: isDesktop ? 1 : 0.7,
          stagger: {
            amount: 0.6,
            axis: "x", 
            ease: "back.easeOut",
            from: active,
          },
          onComplete:onCompleted(1),
        }
      );
    }else{
      onCompleted(0)
    }
  }
  
  if(isDesktop){

    function scrollWheel(event) {
      //event.preventDefault();
      if(okDelta==true){
        yy = Math.min(Math.max(-100, event.deltaY * 10), 100) ;
        //console.log("okDelta " + yy)
        if (!executed) {
          if(yy >= 100 && active < maxLength - 1){
            executed = true
            animateNext()
            //console.log("UP" + maxLength)
          }else if(yy <= -100 && active >= 1){
            executed = true
            animatePrev()
            //console.log("DOWN" + maxLength)
          }
        }
      }else{
        console.log("Nothing")
      } 
    }
    let yy = 0;
    const el = document.querySelector(".main_container");
    el.onwheel = scrollWheel;

    /*=================================================

      Key

    ==================================================== */

    /* const input = document.querySelector("input");
    const log = document.getElementById("log"); */

    document.addEventListener("keydown", logKey);

    function logKey(eKey) {
      //log.textContent += ` ${e.code}`;
      console.log(eKey.key)
      if(eKey.key == "ArrowRight"){
        if (!executed) {
          executed = true
          animateNext()
        }
      }else if(eKey.key == "ArrowLeft"){
        if (!executed) {
          executed = true
          animatePrev()
        }
      }
    }

    
  }else if(isMobile){
    function count_D(mouseProgress) {
      if (mouseProgress > 50){
        mouseProgress = 0
        if (!executed) {
          executed = true;
          animateNext()
        }
      } else if (mouseProgress < -50){
        mouseProgress = 0
        if (!executed) {
          executed = true;
          animatePrev()
        }
      }
    }

    const handleMouseMove = (e) => {
      if (!isDown) return
      const x = e.clientX || (e.touches && e.touches[0].clientX) || 0
      const mouseProgress = (x - startX) * speedDrag *100
      progress = progress + mouseProgress
      startX = x
      console.log(mouseProgress)
      count_D(mouseProgress)
    }
    const handleMouseDown = e => {
      isDown = true
      startX = e.clientX || (e.touches && e.touches[0].clientX) || 0
    }
    const handleMouseUp = () => {
      isDown = false
    }

    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
    document.addEventListener('touchstart', handleMouseDown)
    document.addEventListener('touchmove', handleMouseMove)
    document.addEventListener('touchend', handleMouseUp)

  }return () => { 
    console.log("NONE")
  }
  
  

  /*--------------------
  Listeners
  --------------------*/

  //document.addEventListener('mousewheel', handleWheel)
  /* document.addEventListener('mousedown', handleMouseDown)
  document.addEventListener('mousemove', handleMouseMove)
  document.addEventListener('mouseup', handleMouseUp)
  document.addEventListener('touchstart', handleMouseDown)
  document.addEventListener('touchmove', handleMouseMove)
  document.addEventListener('touchend', handleMouseUp) */

  /*--------------------
    OLD
    --------------------*/
  /* if(isDesktop){
    console.log('isDesktop wheel')
    const handleWheel = e => {
      const wheelProgress = e.deltaY * speedWheel
      let wheelP = Math.floor(wheelProgress * -100)*5
      console.log('wheel..')
      count_W(wheelP)
    }
    document.addEventListener('wheel', handleWheel)
    
    
    const handleMouseMove = (e) => {
      if (!isDown) return
      const x = e.clientX || (e.touches && e.touches[0].clientX) || 0
      const mouseProgress = (x - startX) * speedDrag *100
      progress = progress + mouseProgress
      startX = x
      console.log(mouseProgress)
      count_D(mouseProgress)
    }
    const handleMouseDown = e => {
      isDown = true
      startX = e.clientX || (e.touches && e.touches[0].clientX) || 0
    }
    const handleMouseUp = () => {
      isDown = false
    }

    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
    document.addEventListener('touchstart', handleMouseDown)
    document.addEventListener('touchmove', handleMouseMove)
    document.addEventListener('touchend', handleMouseUp)

  }

  return () => { 
    
  } */
}); 